import * as React from "react";
import { forwardRef } from "react";
const SvgEsway1 = (props: React.SVGProps<SVGSVGElement>, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 330 200"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#esway1_svg__a)">
      <g clipPath="url(#esway1_svg__b)">
        <path
          fill="#EDEAE0"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.563}
          d="M114.652 54.083h-5.027v28.986h5.027z"
        />
        <path
          fill="#EDEAE0"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.451}
          d="M114.652 59.752h-5.027v16.579h5.027z"
        />
        <path
          fill="#EDEAE0"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.563}
          d="M114.652 118.152h-5.027v28.987h5.027zM209.015 118.152h-5.027v28.987h5.027zM209.015 53.12h-5.027v28.986h5.027z"
        />
        <path
          fill="#EDEAE0"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.451}
          d="M114.652 123.821h-5.027V140.4h5.027z"
        />
        <path
          fill="#EDEAE0"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.562}
          d="M203.987 44.027c0-4.913-3.988-8.902-8.901-8.902h-71.213c-4.912 0-8.9 3.989-8.9 8.902v112.064c0 4.914 3.988 8.902 8.9 8.902h71.213c4.913 0 8.901-3.988 8.901-8.902z"
          clipRule="evenodd"
        />
        <path
          fill="#EDEAE0"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.563}
          d="M198.665 48.499a7.84 7.84 0 0 0-7.836-7.837H128.13a7.84 7.84 0 0 0-7.836 7.837v103.122a7.84 7.84 0 0 0 7.836 7.837h62.699a7.84 7.84 0 0 0 7.836-7.837z"
          clipRule="evenodd"
        />
        <circle cx={159.36} cy={108.382} r={6.875} fill="#257676" />
        <circle
          cx={146.298}
          cy={108.694}
          r={4.25}
          fill="#257676"
          fillOpacity={0.8}
        />
        <circle
          cx={165.61}
          cy={96.944}
          r={4.25}
          fill="#257676"
          fillOpacity={0.8}
        />
        <circle
          cx={166.173}
          cy={119.569}
          r={4.25}
          fill="#257676"
          fillOpacity={0.8}
        />
        <circle
          cx={141.548}
          cy={100.007}
          r={2.438}
          fill="#257676"
          fillOpacity={0.6}
        />
        <circle
          cx={160.985}
          cy={128.007}
          r={2.438}
          fill="#257676"
          fillOpacity={0.6}
        />
        <circle
          cx={175.548}
          cy={97.194}
          r={2.438}
          fill="#257676"
          fillOpacity={0.6}
        />
        <circle
          cx={145.173}
          cy={91.444}
          r={1.625}
          fill="#257676"
          fillOpacity={0.4}
        />
        <circle
          cx={181.173}
          cy={104.569}
          r={1.625}
          fill="#257676"
          fillOpacity={0.4}
        />
        <circle
          cx={151.798}
          cy={129.194}
          r={1.625}
          fill="#257676"
          fillOpacity={0.4}
        />
        <path
          fill="#257676"
          d="M129.452 66.944v-9.048h6.709v1.422h-5.119v2.352h4.537v1.435h-4.537v2.417h5.183v1.422zm8.466 0V60.12h1.576v1.047c.453-.633 1.06-1.189 2.133-1.189 1.551 0 2.43 1.021 2.43 2.611v4.356h-1.564v-3.878c0-1.072-.53-1.667-1.46-1.667-.918 0-1.539.62-1.539 1.693v3.852zm10.368.13c-.983 0-2.03-.337-2.896-1.022l.698-1.06c.763.556 1.526.84 2.237.84.672 0 1.06-.284 1.06-.736v-.026c0-.517-.724-.71-1.526-.956-.995-.272-2.133-.699-2.133-1.991v-.026c0-1.306 1.073-2.094 2.431-2.094.866 0 1.783.297 2.507.776l-.62 1.111c-.659-.4-1.358-.646-1.926-.646-.608 0-.957.297-.957.672v.026c0 .491.737.724 1.538.97.983.31 2.12.762 2.12 1.99v.026c0 1.435-1.111 2.146-2.533 2.146m7.264.025c-1.965 0-3.503-1.434-3.503-3.541v-.026c0-1.965 1.383-3.555 3.335-3.555 2.172 0 3.27 1.706 3.27 3.671 0 .142-.013.284-.026.44h-5.015c.168 1.124.944 1.732 1.965 1.732.775 0 1.292-.285 1.848-.815l.918.815c-.659.775-1.538 1.28-2.792 1.28m-1.952-4.045h3.503c-.103-.996-.698-1.797-1.732-1.797-.969 0-1.629.724-1.771 1.797m6.612 3.89V60.12h1.577v1.034c.44-.607 1.034-1.176 2.081-1.176.983 0 1.681.478 2.042 1.202.556-.724 1.267-1.202 2.301-1.202 1.5 0 2.392.944 2.392 2.611v4.356h-1.564v-3.878c0-1.085-.505-1.667-1.384-1.667-.866 0-1.46.595-1.46 1.693v3.852h-1.564v-3.89c0-1.073-.504-1.655-1.383-1.655s-1.461.646-1.461 1.693v3.852zm16.173.142c-1.137 0-1.848-.568-2.326-1.202v1.06h-1.577v-9.436h1.577v3.749c.504-.711 1.202-1.28 2.326-1.28 1.603 0 3.167 1.267 3.167 3.542v.026c0 2.275-1.551 3.541-3.167 3.541m-.374-1.357c1.072 0 1.951-.84 1.951-2.184v-.026c0-1.319-.904-2.185-1.951-2.185-1.073 0-1.991.88-1.991 2.185v.026c0 1.305.918 2.184 1.991 2.184m5.233 1.215v-9.436h1.577v9.436zm6.75.155c-1.965 0-3.503-1.434-3.503-3.541v-.026c0-1.965 1.383-3.555 3.335-3.555 2.171 0 3.27 1.706 3.27 3.671 0 .142-.013.284-.026.44h-5.015c.168 1.124.943 1.732 1.964 1.732.776 0 1.293-.285 1.849-.815l.918.815c-.66.775-1.539 1.28-2.792 1.28m-1.952-4.045h3.503c-.104-.996-.698-1.797-1.732-1.797-.97 0-1.629.724-1.771 1.797m-49.159 18.01c-1.337 0-2.411-.43-3.413-1.337l.585-.692c.871.8 1.706 1.181 2.863 1.181 1.134 0 1.862-.596 1.862-1.42v-.023c0-.776-.418-1.205-2.172-1.587-1.921-.418-2.804-1.038-2.804-2.41v-.024c0-1.3 1.158-2.28 2.745-2.28 1.229 0 2.076.347 2.935 1.027l-.549.728c-.776-.633-1.551-.907-2.41-.907-1.098 0-1.778.585-1.778 1.348v.024c0 .788.418 1.241 2.267 1.623 1.861.417 2.72 1.086 2.72 2.362v.024c0 1.432-1.193 2.363-2.851 2.363m7.393.024c-1.813 0-3.162-1.468-3.162-3.198v-.024c0-1.754 1.349-3.222 3.162-3.222 1.17 0 1.885.478 2.47 1.098l-.608.644c-.49-.513-1.027-.93-1.874-.93-1.253 0-2.207 1.05-2.207 2.386v.024c0 1.336.978 2.398 2.267 2.398.799 0 1.396-.393 1.885-.918l.585.548c-.621.704-1.36 1.194-2.518 1.194m4.06-7.66v-1.015h1.05v1.014zm.06 7.516v-6.168h.919v6.168zm5.748.144c-1.683 0-3.079-1.301-3.079-3.21v-.024c0-1.778 1.241-3.21 2.959-3.21 1.826 0 2.876 1.456 2.876 3.258 0 .131 0 .19-.012.298h-4.892c.131 1.336 1.074 2.088 2.172 2.088.859 0 1.431-.346 1.944-.87l.573.512c-.62.704-1.36 1.157-2.541 1.157m-2.148-3.568h3.973c-.095-1.11-.728-2.1-1.969-2.1-1.085 0-1.873.907-2.004 2.1m6.512 3.424v-6.168h.919v1.073c.418-.668 1.05-1.205 2.112-1.205 1.479 0 2.362 1.003 2.362 2.47v3.83h-.918v-3.603c0-1.145-.609-1.861-1.707-1.861-1.061 0-1.849.775-1.849 1.932v3.532zm9.417.108c-1.002 0-1.742-.49-1.742-1.742v-3.723h-.859v-.811h.859v-1.862h.919v1.862h1.957v.81H167.1v3.604c0 .764.417 1.026 1.038 1.026.322 0 .572-.06.895-.214v.787c-.323.18-.669.263-1.11.263m2.784-7.625v-1.014h1.05v1.014zm.059 7.517v-6.168h.919v6.168zm3.397 0v-5.357h-.847v-.8h.847v-.536c0-.704.179-1.23.537-1.587.322-.323.764-.478 1.325-.478.429 0 .716.048 1.014.155v.8c-.334-.096-.573-.155-.895-.155-.716 0-1.074.441-1.074 1.312v.501h1.957v.788h-1.945v5.357zm4.129 0v-6.168h.906v6.168zm-.072-7.517v-1.014h1.05v1.014zm5.905 7.66c-1.814 0-3.162-1.467-3.162-3.197v-.024c0-1.754 1.348-3.222 3.162-3.222 1.169 0 1.885.478 2.47 1.098l-.609.644c-.489-.513-1.026-.93-1.873-.93-1.253 0-2.208 1.05-2.208 2.386v.024c0 1.336.979 2.398 2.267 2.398.8 0 1.396-.393 1.886-.918l.584.548c-.62.704-1.36 1.194-2.517 1.194"
        />
      </g>
      <g clipPath="url(#esway1_svg__c)">
        <path fill="#3F4142" d="M273.875 192h-5v7.5h5z" />
        <path
          fill="#EDEAE0"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m255.456 192.205-7.415-28.387h46.571l-7 28.26z"
          clipRule="evenodd"
        />
        <path
          fill="#EDEAE0"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M277.751 57.875H263.28v5.992h14.471zM298.845 91.962h-6.396v9.267h6.396zM247.562 91.962h-5.513v9.267h5.513z"
        />
        <path
          fill="#EDEAE0"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m232.316 87.4-.045-8.077 14.244-15.437 46.729-.02 15.512 14.656-.245 8.878z"
          clipRule="evenodd"
        />
        <path
          fill="#257676"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M297.987 158.998c0-.887-.72-1.606-1.608-1.606h-52.135c-.887 0-1.607.719-1.607 1.606v3.214c0 .886.72 1.607 1.607 1.607h52.135c.888 0 1.608-.721 1.608-1.607z"
          clipRule="evenodd"
        />
        <path
          fill="#EDEAE0"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M303.822 105.705a4.48 4.48 0 0 0-4.477-4.476H241.01a4.48 4.48 0 0 0-4.477 4.476 4.48 4.48 0 0 0 4.477 4.477h58.335a4.48 4.48 0 0 0 4.477-4.477M245.667 142.017l-12.571 15.375h74.431l-12.39-15.737zM244.311 126.28l-12.572 15.375h74.432l-12.391-15.737z"
          clipRule="evenodd"
        />
        <path
          fill="#EDEAE0"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m245.667 110.543-12.571 15.376h74.431l-12.39-15.737z"
          clipRule="evenodd"
        />
        <path
          fill="#EDEAE0"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M311.529 85.866H229.5v6.602h82.029z"
        />
        <path
          fill="#868686"
          fillOpacity={0.2}
          fillRule="evenodd"
          d="m288.759 63.866 14.946 16.078.695 5.909 4.358.13v-7.212l-15.263-14.905zM291.285 110.375l8.391 15.543h7.852l-12.194-15.736zM290.387 126.362l8.391 15.543h7.851l-12.194-15.736zM291.285 141.848l8.391 15.544h7.852l-12.194-15.737zM290.417 163.78l-8.19 28.3 5.348.124 6.785-28.13z"
          clipRule="evenodd"
        />
        <path
          fill="#868686"
          fillOpacity={0.2}
          d="M277.75 57.875h-2.322v5.992h2.322zM311.077 85.866h-3.851v5.992h3.851z"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m245.666 142.017-12.571 15.375h74.432l-12.389-15.737zm-1.356-15.737-12.571 15.375h74.431l-12.39-15.736zm1.356-15.736-12.571 15.375h74.432l-12.389-15.737zm-13.357-24.678-.037-6.543 14.244-15.437 46.728-.02 15.514 14.656-.203 7.344h2.974v6.603h-12.684v8.76h.497a4.48 4.48 0 0 1 4.477 4.476 4.48 4.48 0 0 1-4.477 4.477h-58.333a4.48 4.48 0 0 1-4.476-4.477 4.48 4.48 0 0 1 4.476-4.476h1.04v-8.76H229.5v-6.603zm15.253 6.603v8.76h44.887v-8.76zm30.188-34.594h-14.47v5.992h14.47z"
          clipRule="evenodd"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M311.529 85.866H229.5v6.602h82.029z"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m255.456 192.205-7.415-28.387h46.571l-7 28.26z"
          clipRule="evenodd"
        />
      </g>
      <path
        fill="#D9D9D9"
        fillOpacity={0.66}
        d="M270.5.5c7.318 0 13.25 5.932 13.25 13.25S277.818 27 270.5 27q-1.053-.001-2.062-.16c6.338-.99 11.187-6.474 11.187-13.09S274.776 1.65 268.438.66A13.3 13.3 0 0 1 270.5.5"
      />
      <circle
        cx={270.5}
        cy={13.75}
        r={12.625}
        stroke="#3F4142"
        strokeWidth={1.25}
      />
      <path
        fill="#EDEAE0"
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M285.25 13.75h-29.5v3h29.5z"
      />
      <path
        fill="#868686"
        fillOpacity={0.2}
        d="M285.25 13.75h-5.125v3h5.125z"
      />
      <path
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M285.25 13.75h-29.5v3h29.5z"
      />
      <path
        fill="#EDEAE0"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M223.75 25.25v-3.022c9.924-2.76 15.521-3.97 25.57-5.478h41c10.82 1.363 16.734 2.47 26.825 5.478v3.022z"
        clipRule="evenodd"
      />
      <path
        fill="#868686"
        fillOpacity={0.2}
        d="m305.258 19.25-15.938-2.375 21 8.313h6.813V22.5z"
      />
      <path
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M223.75 25.25v-3.022c9.924-2.76 15.521-3.97 25.57-5.478h41c10.82 1.363 16.734 2.47 26.825 5.478v3.022z"
        clipRule="evenodd"
      />
      <path
        fill="#EDEAE0"
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M291.625 25.25H249.25v13.5h42.375z"
      />
      <path
        fill="#868686"
        fillOpacity={0.2}
        d="M291 25.25h-41.562v4.625h34.937v8.875H291z"
      />
      <path
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M291.625 25.25H249.25v13.5h42.375z"
      />
      <path
        fill="#EDEAE0"
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M311.404 38.75h-82.029v6.602h82.029z"
      />
      <path fill="#868686" fillOpacity={0.2} d="M311 38.75h-13v6h13z" />
      <path
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M311.404 38.75h-82.029v6.602h82.029z"
      />
      <path fill="#3F4142" d="M273 45.375h-5v7.5h5z" />
      <path
        fill="#8C8C8C"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.36}
        d="m17.851 112.105-.257 53.892 1.801 4.83 1.845-5.167v-53.555zM25.592 112.105l-.257 53.892 1.802 4.83 1.844-5.167v-53.555zM33.295 112.105l-.258 53.892 1.802 4.83 1.844-5.167v-53.555z"
        clipRule="evenodd"
      />
      <path fill="#3F4142" d="M29.77 71.25h-5v7.5h5z" />
      <path
        fill="#257676"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={1.25}
        d="M41.19 81.545a2.807 2.807 0 0 0-2.806-2.807H15.932a2.81 2.81 0 0 0-2.807 2.807v36.625a2.81 2.81 0 0 0 2.807 2.807h22.452a2.81 2.81 0 0 0 2.806-2.807z"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 84.175c0-.67-.544-1.215-1.215-1.215H17.19a1.216 1.216 0 0 0 0 2.43h19.935c.67 0 1.215-.544 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 82.96h.847a1.216 1.216 0 0 1 0 2.43h-4.02c2.3-.624 3.556-1.456 3.173-2.43"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 89.463c0-.67-.544-1.215-1.215-1.215H17.19a1.216 1.216 0 0 0 0 2.43h19.935c.67 0 1.215-.544 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 88.248h.847a1.216 1.216 0 0 1 0 2.43h-4.02c2.3-.624 3.556-1.456 3.173-2.43"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 115.904c0-.671-.544-1.216-1.215-1.216H17.19a1.216 1.216 0 0 0 0 2.431h19.935c.67 0 1.215-.544 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 114.688h.847a1.217 1.217 0 0 1 0 2.431h-4.02c2.3-.625 3.556-1.457 3.173-2.431"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 94.752c0-.671-.544-1.216-1.215-1.216H17.19a1.216 1.216 0 0 0 0 2.43h19.935c.67 0 1.215-.544 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 93.536h.847a1.216 1.216 0 0 1 0 2.431h-4.02c2.3-.625 3.556-1.457 3.173-2.43"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 100.04c0-.671-.544-1.216-1.215-1.216H17.19a1.216 1.216 0 0 0 0 2.431h19.935c.67 0 1.215-.545 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 98.824h.847a1.216 1.216 0 0 1 0 2.431h-4.02c2.3-.625 3.556-1.457 3.173-2.43"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 105.328c0-.671-.544-1.216-1.215-1.216H17.19a1.216 1.216 0 0 0 0 2.431h19.935c.67 0 1.215-.545 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 104.112h.847a1.217 1.217 0 0 1 0 2.431h-4.02c2.3-.625 3.556-1.457 3.173-2.431"
        clipRule="evenodd"
      />
      <path
        fill="#2C6767"
        fillRule="evenodd"
        stroke="#3F4142"
        strokeLinejoin="round"
        strokeMiterlimit={1.5}
        strokeWidth={0.512}
        d="M38.341 110.616c0-.671-.544-1.216-1.215-1.216H17.19a1.216 1.216 0 0 0 0 2.431h19.935c.67 0 1.215-.544 1.215-1.215Z"
        clipRule="evenodd"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M36.278 109.4h.847a1.217 1.217 0 0 1 0 2.431h-4.02c2.3-.625 3.556-1.457 3.173-2.431M20.39 120.977l-.195 44.533-1.574 3.233.796 2.085 1.822-5.238v-44.588zM28.223 120.977l-.196 44.533-1.574 3.233.796 2.085 1.823-5.238v-44.588zM35.836 120.977l-.196 44.533-1.574 3.233.796 2.085 1.823-5.238v-44.588z"
        clipRule="evenodd"
      />
      <g clipPath="url(#esway1_svg__d)">
        <path fill="#3F4142" d="M62.5 71.25h-5v7.5h5z" />
        <path
          fill="#257676"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M67.875 92.375h-15.75v82.375h15.75z"
        />
        <path
          fill="#A7C7C6"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M67.817 107.049H52.174v67.642h15.643z"
        />
        <path
          fill="#8C8C8C"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.301}
          d="M67.817 111.841H52.174v58.914h15.643z"
        />
        <path
          fill="#257676"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M70.49 80.057c0-.752-.61-1.364-1.363-1.364H50.863c-.752 0-1.363.612-1.363 1.364v10.91c0 .753.61 1.364 1.363 1.364h18.264c.753 0 1.364-.611 1.364-1.364z"
          clipRule="evenodd"
        />
        <path
          fill="#D9D9D9"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={0.52}
          d="M58.344 116.326c.69 0 1.249-.587 1.249-1.312 0-.724-.56-1.312-1.25-1.312-.689 0-1.248.588-1.248 1.312s.559 1.312 1.249 1.312M58.344 121.417c.69 0 1.249-.588 1.249-1.312s-.56-1.312-1.25-1.312c-.689 0-1.248.587-1.248 1.312 0 .724.559 1.312 1.249 1.312M58.344 126.508c.69 0 1.249-.588 1.249-1.312s-.56-1.312-1.25-1.312c-.689 0-1.248.587-1.248 1.312 0 .724.559 1.312 1.249 1.312M58.344 131.598c.69 0 1.249-.587 1.249-1.311 0-.725-.56-1.312-1.25-1.312-.689 0-1.248.587-1.248 1.312 0 .724.559 1.311 1.249 1.311M58.344 136.689c.69 0 1.249-.587 1.249-1.312 0-.724-.56-1.312-1.25-1.312-.689 0-1.248.588-1.248 1.312s.559 1.312 1.249 1.312M58.344 141.781c.69 0 1.249-.587 1.249-1.312 0-.724-.56-1.312-1.25-1.312-.689 0-1.248.588-1.248 1.312s.559 1.312 1.249 1.312M58.344 146.872c.69 0 1.249-.588 1.249-1.312s-.56-1.312-1.25-1.312c-.689 0-1.248.587-1.248 1.312 0 .724.559 1.312 1.249 1.312M58.344 151.963c.69 0 1.249-.588 1.249-1.312s-.56-1.312-1.25-1.312c-.689 0-1.248.587-1.248 1.312 0 .724.559 1.312 1.249 1.312M58.344 167.236c.69 0 1.249-.587 1.249-1.312 0-.724-.56-1.312-1.25-1.312-.689 0-1.248.588-1.248 1.312s.559 1.312 1.249 1.312M58.344 157.053c.69 0 1.249-.587 1.249-1.311 0-.725-.56-1.312-1.25-1.312-.689 0-1.248.587-1.248 1.312 0 .724.559 1.311 1.249 1.311M58.344 162.145c.69 0 1.249-.587 1.249-1.312 0-.724-.56-1.312-1.25-1.312-.689 0-1.248.588-1.248 1.312s.559 1.312 1.249 1.312M61.769 168.997c.69 0 1.249-.588 1.249-1.312s-.56-1.312-1.25-1.312-1.248.587-1.248 1.312c0 .724.559 1.312 1.249 1.312M61.918 118.331c.69 0 1.25-.588 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M61.918 123.422c.69 0 1.25-.588 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M61.918 128.512c.69 0 1.25-.587 1.25-1.311 0-.725-.56-1.312-1.25-1.312s-1.25.587-1.25 1.312c0 .724.56 1.311 1.25 1.311M61.918 133.603c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.312-1.25-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M61.918 138.695c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.312-1.25-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M61.918 143.786c.69 0 1.25-.587 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312.56 1.312 1.25 1.312M61.918 148.877c.69 0 1.25-.588 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M61.918 164.15c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.312-1.25-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M61.918 153.968c.69 0 1.25-.588 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M61.918 159.059c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.311-1.25-1.311s-1.25.587-1.25 1.311c0 .725.56 1.312 1.25 1.312M65.343 167.286c.69 0 1.25-.587 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312.56 1.312 1.25 1.312M65.37 116.452c.69 0 1.25-.587 1.25-1.312s-.56-1.312-1.25-1.312-1.249.587-1.249 1.312.56 1.312 1.25 1.312M65.37 121.404c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.312-1.25-1.312s-1.249.588-1.249 1.312.56 1.312 1.25 1.312M65.37 126.495c.69 0 1.25-.587 1.25-1.312s-.56-1.312-1.25-1.312-1.249.587-1.249 1.312.56 1.312 1.25 1.312M65.37 131.587c.69 0 1.25-.588 1.25-1.312s-.56-1.312-1.25-1.312-1.249.587-1.249 1.312c0 .724.56 1.312 1.25 1.312M65.37 136.677c.69 0 1.25-.587 1.25-1.311 0-.725-.56-1.312-1.25-1.312s-1.249.587-1.249 1.312c0 .724.56 1.311 1.25 1.311M65.37 141.768c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.311-1.25-1.311s-1.249.587-1.249 1.311c0 .725.56 1.312 1.25 1.312M65.37 146.859c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.312-1.25-1.312s-1.249.588-1.249 1.312.56 1.312 1.25 1.312M65.343 162.145c.69 0 1.25-.587 1.25-1.312 0-.724-.56-1.312-1.25-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M65.343 151.963c.69 0 1.25-.588 1.25-1.312s-.56-1.312-1.25-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M65.343 157.053c.69 0 1.25-.587 1.25-1.311 0-.725-.56-1.312-1.25-1.312s-1.25.587-1.25 1.312c0 .724.56 1.311 1.25 1.311M54.92 169.247c.689 0 1.248-.588 1.248-1.312s-.559-1.312-1.249-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M54.92 118.399c.689 0 1.248-.587 1.248-1.312 0-.724-.559-1.312-1.249-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M54.92 123.49c.689 0 1.248-.587 1.248-1.312 0-.724-.559-1.312-1.249-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M54.92 128.581c.689 0 1.248-.588 1.248-1.312s-.559-1.312-1.249-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M54.92 133.673c.689 0 1.248-.588 1.248-1.312s-.559-1.312-1.249-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M54.92 138.763c.689 0 1.248-.587 1.248-1.311 0-.725-.559-1.312-1.249-1.312s-1.25.587-1.25 1.312c0 .724.56 1.311 1.25 1.311M54.92 143.854c.689 0 1.248-.587 1.248-1.312 0-.724-.559-1.312-1.249-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M54.92 148.945c.689 0 1.248-.587 1.248-1.312 0-.724-.559-1.312-1.249-1.312s-1.25.588-1.25 1.312.56 1.312 1.25 1.312M54.92 164.219c.689 0 1.248-.588 1.248-1.312s-.559-1.312-1.249-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312M54.92 154.036c.689 0 1.248-.587 1.248-1.312s-.559-1.312-1.249-1.312-1.25.587-1.25 1.312.56 1.312 1.25 1.312M54.92 159.128c.689 0 1.248-.588 1.248-1.312s-.559-1.312-1.249-1.312-1.25.587-1.25 1.312c0 .724.56 1.312 1.25 1.312"
        />
        <path
          fill="#257676"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m52.174 174.617 15.642.103s-5.123 3.155-7.753 3.155-7.89-3.258-7.89-3.258"
          clipRule="evenodd"
        />
        <path
          fill="#595959"
          fillOpacity={0.2}
          fillRule="evenodd"
          d="M66.438 78.693v13.638h-.836l-.885 82.286-3.967 3.07 7.066-3.07V92.331s1.963.455 2.559-.644c.599-1.099 0-12.687 0-12.687z"
          clipRule="evenodd"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M67.817 92.331H52.174v82.359h15.643z"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M67.817 107.049H52.174v67.642h15.643z"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M67.817 111.841H52.174v58.914h15.643z"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M70.49 80.057c0-.752-.61-1.364-1.363-1.364H50.863c-.752 0-1.363.612-1.363 1.364v10.91c0 .753.61 1.364 1.363 1.364h18.264c.753 0 1.364-.611 1.364-1.364zM52.174 174.72h15.639s-4.557 3.133-7.688 3.133-7.951-3.133-7.951-3.133"
          clipRule="evenodd"
        />
      </g>
      <g clipPath="url(#esway1_svg__e)">
        <path fill="#3F4142" d="M89.125 71.25h-5v7.5h5z" />
        <path fill="#A7C7C6" d="M89.637 88.092h-5.968v12.942h5.968z" />
        <path
          fill="#257676"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m86.653 107.376-6.745.014-.08-13.309 2.09-5.936.295-9.364 4.44.045 4.44-.045.294 9.364 2.09 5.936-.08 13.309z"
          clipRule="evenodd"
        />
        <path
          fill="#8C8C8C"
          fillRule="evenodd"
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="M78.375 107.391v82.338l3.302 3.837 10.327-.083 2.927-3.754v-82.338z"
          clipRule="evenodd"
        />
        <path
          fill="#595959"
          fillOpacity={0.2}
          fillRule="evenodd"
          d="M94.931 107.391h-2.95v82.393l-2.106 3.782h2.404l2.652-3.782zM88.507 78.781l.49 9.31 2.341 6.034-.342 12.847 2.48-.021V94.269l-2.114-6.424-.366-9.064h-2"
          clipRule="evenodd"
        />
        <path
          stroke="#3F4142"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          strokeWidth={1.25}
          d="m86.653 107.376-6.745.014-.08-13.309 2.09-5.936.295-9.364 4.44.045 4.44-.045.294 9.364 2.09 5.936-.08 13.309zM78.375 107.391v82.338l3.302 3.837 10.327-.083 2.927-3.754v-82.338z"
          clipRule="evenodd"
        />
      </g>
      <path fill="#3F4142" d="M31.625 5.25h-5v7.5h5z" />
      <path
        fill="#EDEAE0"
        stroke="#3F4142"
        strokeWidth={1.25}
        d="M21.25 27.125H37V66.5H21.25z"
      />
      <rect
        width={22.25}
        height={14.875}
        x={18}
        y={12.75}
        fill="#257676"
        stroke="#3F4142"
        strokeWidth={1.25}
        rx={2.25}
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        d="M33.375 27.625H37V66h-3.625zM34.875 13.125c0-.207.168-.375.375-.375H38A2.25 2.25 0 0 1 40.25 15v10.375a2.25 2.25 0 0 1-2.25 2.25h-2.75a.375.375 0 0 1-.375-.375z"
      />
      <path
        stroke="#3F4142"
        strokeWidth={1.25}
        d="M21.25 27.625H37V66.5H21.25z"
      />
      <rect
        width={22.25}
        height={14.875}
        x={18}
        y={12.75}
        stroke="#3F4142"
        strokeWidth={1.25}
        rx={2.25}
      />
      <path fill="#3F4142" d="M71.875 5.25h-5v7.5h5z" />
      <path
        fill="#8C8C8C"
        stroke="#3F4142"
        strokeWidth={1.25}
        d="M63.25 30.428v-7.303H75.5v7.303z"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M72 29.964h3.5v-6.22H72z"
        clipRule="evenodd"
      />
      <path
        stroke="#3F4142"
        strokeWidth={1.25}
        d="M63.25 30.428v-7.303H75.5v7.303z"
      />
      <rect
        width={11.125}
        height={15}
        x={61.875}
        y={23.375}
        fill="#257676"
        stroke="#3F4142"
        strokeWidth={1.25}
        rx={1.875}
        transform="rotate(-90 61.875 23.375)"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="M73.5 23.125h3.125V12.5H73.5z"
        clipRule="evenodd"
      />
      <rect
        width={11.125}
        height={15}
        x={61.875}
        y={23.375}
        stroke="#3F4142"
        strokeWidth={1.25}
        rx={1.875}
        transform="rotate(-90 61.875 23.375)"
      />
      <mask id="esway1_svg__f" fill="#fff">
        <path d="M77.25 38.375H89.5v15.75H49.25v-15.75H61.5V28.75h15.75z" />
      </mask>
      <path
        fill="#EDEAE0"
        d="M77.25 38.375H89.5v15.75H49.25v-15.75H61.5V28.75h15.75z"
      />
      <path
        fill="#3F4142"
        d="M77.25 38.375H76v1.25h1.25zm12.25 0h1.25v-1.25H89.5zm0 15.75v1.25h1.25v-1.25zm-40.25 0H48v1.25h1.25zm0-15.75v-1.25H48v1.25zm12.25 0v1.25h1.25v-1.25zm0-9.625V27.5h-1.25v1.25zm15.75 0h1.25V27.5h-1.25zm0 9.625v1.25H89.5v-2.5H77.25zm12.25 0h-1.25v15.75h2.5v-15.75zm0 15.75v-1.25H49.25v2.5H89.5zm-40.25 0h1.25v-15.75H48v15.75zm0-15.75v1.25H61.5v-2.5H49.25zm12.25 0h1.25V28.75h-2.5v9.625zm0-9.625V30h15.75v-2.5H61.5zm15.75 0H76v9.625h2.5V28.75z"
        mask="url(#esway1_svg__f)"
      />
      <path
        fill="#595959"
        fillOpacity={0.2}
        fillRule="evenodd"
        d="m73.5 42.5 3.125-3.438v-9.687H73.5zM50.125 53.413 89 53.625v-2.5H50.125z"
        clipRule="evenodd"
      />
      <mask id="esway1_svg__g" fill="#fff">
        <path d="M77.25 38.375H89.5v15.75H49.25v-15.75H61.5V28.75h15.75z" />
      </mask>
      <path
        fill="#3F4142"
        d="M77.25 38.375H76v1.25h1.25zm12.25 0h1.25v-1.25H89.5zm0 15.75v1.25h1.25v-1.25zm-40.25 0H48v1.25h1.25zm0-15.75v-1.25H48v1.25zm12.25 0v1.25h1.25v-1.25zm0-9.625V27.5h-1.25v1.25zm15.75 0h1.25V27.5h-1.25zm0 9.625v1.25H89.5v-2.5H77.25zm12.25 0h-1.25v15.75h2.5v-15.75zm0 15.75v-1.25H49.25v2.5H89.5zm-40.25 0h1.25v-15.75H48v15.75zm0-15.75v1.25H61.5v-2.5H49.25zm12.25 0h1.25V28.75h-2.5v9.625zm0-9.625V30h15.75v-2.5H61.5zm15.75 0H76v9.625h2.5V28.75z"
        mask="url(#esway1_svg__g)"
      />
    </g>
    <defs>
      <clipPath id="esway1_svg__a">
        <path fill="#fff" d="M0 0h330v200H0z" />
      </clipPath>
      <clipPath id="esway1_svg__b">
        <path fill="#fff" d="M108.375 33.875H210.25V166.25H108.375z" />
      </clipPath>
      <clipPath id="esway1_svg__c">
        <path fill="#fff" d="M228.25 56.625h84.5V200.75h-84.5z" />
      </clipPath>
      <clipPath id="esway1_svg__d">
        <path fill="#fff" d="M48.25 70h23.625v109.125H48.25z" />
      </clipPath>
      <clipPath id="esway1_svg__e">
        <path fill="#fff" d="M77.125 70h19v124.875h-19z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgEsway1);
export default ForwardRef;

